
export function isValidDate(dateStringMMDDYYYY?: string, minYear = 1980, maxYear = new Date().getFullYear()): boolean {
  if (dateStringMMDDYYYY === "") {
    return true
  }
  if (!dateStringMMDDYYYY) {
    return false
  }
  if (dateStringMMDDYYYY.length < 6) {
    return false
  }
  if (dateStringMMDDYYYY.split("/").length != 3 && dateStringMMDDYYYY.split("-").length != 3) {
    return false
  }

  try {
    const date = new Date(dateStringMMDDYYYY)
    if (date.getFullYear() < minYear || date.getFullYear() > maxYear) {
      return false
    }
    console.log(date.toISOString())
  } catch {
    return false
  }

  console.log(dateStringMMDDYYYY + " is valid")


  return true
}